<template>

    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="col-lg-12 mb-4" v-else>
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">Uniform Review</div>
                    </div>
                    <div class="form mt-3">
                        <div class="row align-items-center">
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">Employee Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="`${request.employee.name} ${request.employee.last_name}`"
                                        readonly
                                    >
                                </div>
                            </div>
                            <div class="col-md-6 d-flex flex-wrap">
                                <div class="form-group form-group-2 mr-4">
                                    <label for="" class="form-label">Does the employee want this uniform to be delivered
                                        to the primary location or to the main office?</label>
                                </div>
                                <div class="d-flex">
                                    <div class="form-group form-group-2 mr-3">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-checkbox"
                                                type="radio"
                                                name="name12"
                                                id="office"
                                                :value=1
                                                v-model="request.isMainOffice"
                                                @change="clearLocation"
                                            >
                                            <label class="form-check-label" for="office">
                                                <nobr> Main Office</nobr>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group form-group-2 mr-3">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-checkbox"
                                                type="radio" name="name12"
                                                id="primary"
                                                :value=0
                                                v-model="request.isMainOffice"
                                            >
                                            <label class="form-check-label" for="primary">
                                                <nobr>Primary Location</nobr>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="!request.isMainOffice">
                                <div class="form-group form-group-2">
                                    <label for="" class="form-label">Primary Location</label>
                                    <select class="form-control" v-model="request.location">
                                        <option
                                            v-for="client in clientsList"
                                            :key="client.id"
                                            :value="client.id"
                                        >
                                            {{ client.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row align-items-center col-md-12">
                                <div class="col-md-6">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Item</label>
                                        <input type="text" class="form-control" :value="request.uniform.title" readonly>
                                    </div>
                                </div>
                                <div class="col-6 col-md-2">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Size</label>
                                        <input type="text" class="form-control" v-model="request.size">
                                    </div>
                                </div>
                                <div class="col-6 col-md-2">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Quantity</label>
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="request.quantity"
                                            min="0"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">Comments</label>
                                    <textarea type="text" class="form-control height-2"
                                              v-model="request.comment"></textarea>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">Status</label>
                                    <select
                                        class="custom-select custom-select-blue"
                                        v-model="request.status_id"
                                    >
                                        <option
                                            v-for="status in statusList"
                                            :key="status.id"
                                            :value="status.id"
                                            :selected="request.status_id"
                                        >
                                            {{ status.title }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class=" col-md-6 text-md-right">
                                <div class="form-group form-group-1">
                                    <span class="color--text-gray">Delete this uniform  </span>
                                    <a href="javascript:void(0)" class="delete-link"
                                       @click="showDeleteModal"
                                    ><img src="/img/svg/on.svg" alt="delete"></a>
                                    <ActionModal confirm-text="Yes" reject-text="No"
                                                 :modalId="`deleteModal`"
                                                 @confirm="deleteRequestItem">
                                        <template #body>
                                            <div class="text-center mb-4">
                                                <h4>
                                                    Are you sure you want <br> to delete this item?
                                                </h4>
                                            </div>
                                        </template>
                                    </ActionModal>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="btns-wrap">
                                    <a href="/master-admin/uniforms/log"
                                       class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                                    <a class="btn btn--secondary w-100 w-sm-auto" @click="updateRequest">Save</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import UniformsService from "./service/UniformsService";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import CommonService from "../../../AppUser/resources/js/services/CommonService";

export default {
    name: 'UniformRequestItem',
    props: {
        id: Number
    },
    components: {ActionModal},
    data() {
        return {
            request: {
                employee_id: null,
                comment: null,
                requested_id: null,
                size: null,
                status: null,
                uniform_id: null,
                location: null,
                quantity: null,
            },
            filters: {
                search: '',
                sortBy: 'title',
                sortDir: 'asc'
            },
            applicantsList: [],
            clientsList: [],
            loading: true,
            requestLocation: null,
            statusList: [],
            urlData: {
                type: null,
                id: null,
            }
        }
    },
    methods: {
        checkUrlParams(urlData) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.has('applicant_id')) {
                urlData.type = 'applicant_id';
                urlData.id = urlParams.get('applicant_id');
                this.request.employee_id = Number(urlData.id)
            } else {
                urlData.type = 'create';
                urlData.id = null;
            }
        },
        clearLocation() {
            this.request.location = null
        },
        async deleteRequestItem() {
            this.$showLoadingMessage()
            try {
                await UniformsService.deleteRequest(this.id)
                this.$showSuccessMessageDelete();
                if (this.urlData.type === 'applicant_id') {
                    setTimeout(() => {
                        window.location.href = `/master-admin/applicants/${this.urlData.id}/show?tab=Uniforms`
                    }, 1000)
                } else {
                    setTimeout(() => {
                        window.location.href = '/master-admin/uniforms/log'
                    }, 1000)
                }
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        async getClientsList() {
            try {
                const {data: clients} = await CommonService.getClientsList()
                this.clientsList = clients
            } catch (e) {
                console.error()
            }
        },
        async getCurrentItem() {
            try {
                const {data: requestInfo} = await UniformsService.getRequestInfo(this.id)
                this.request = requestInfo
            } catch {
                this.$showErrorMessage();
            }
        },
        async getStatusesList() {
            try {
                const {data: statuses} = await UniformsService.getStatusList()
                this.statusList = statuses
            } catch (e) {
                this.$showErrorMessage();
            }
        },
        showDeleteModal() {
            $(`#deleteModal`).modal()
        },
        async updateRequest() {
            if (!this.request.quantity) {
                this.$showErrorMessage('Please enter quantity');
            } else {
                this.$showLoadingMessage()
                try {
                    await UniformsService.updateRequestItem(this.id, this.request)
                    this.$showSuccessMessage('The request was updated!')
                    if (this.urlData.type === 'applicant_id') {
                        setTimeout(() => {
                            window.location.href = `/master-admin/applicants/${this.urlData.id}/show?tab=Uniforms`
                        }, 1000)
                    } else {
                        setTimeout(() => {
                            window.location.href = '/master-admin/uniforms/log'
                        }, 1000)
                    }
                } catch (e) {
                    this.$showErrorMessage('The request was not updated ');
                }
            }
        },
        async loadData() {
            this.loading = true;

            try {
                await Promise.all([
                    this.getCurrentItem(),
                    this.getClientsList(),
                    this.getStatusesList(),
                ]);
            } catch (e) {
                console.error("Error loading data");
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.checkUrlParams(this.urlData)
        this.loadData()
    }

}

</script>


<style scoped>

</style>
